/* eslint-disable @next/next/no-img-element */
import {
  getFirst150Characters,
  removeBreakLinesAndSpaces,
} from '@/helpers/stringHelpers';
import { useSEO } from '@/hooks/useSEO';
import { useMediaQuery } from '@mui/material';
import { AxiosError } from 'axios';
import cookieCommons from 'common/cookieCommons';
import TrainingSectionHeader from 'layouts/components/navs/TrainingSectionHeader';
import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { getMineRoleOfFolder } from '../../../apis/tms/share';
import { getFolderInfo } from '../../../apis/tms/training.api';
import { checkIsUserJoined } from '../../../common/checkRoleUser';
import GeneralGroupInfoBar from '../../../components/elements/group/GeneralGroupInfoBar';
import TabsInGroupDetail from '../../../components/elements/group/TabsInGroupDetail';
import { FilledVectorLeft } from '../../../components/elements/svgIcon/filled';
import { SearchIcon } from '../../../components/elements/svgIcon/outlined';
import SearchInput from '../../../components/input/SearchInput2';
import { PATH_NAME } from '../../../configs/pathName';
import { FOLDER_INFO, GROUP_ROLE_ACCESS } from '../../../constant/QueryKeyName';
import { ROLE_ACCESS, TRoleAccess } from '../../../constant/storage';
import { routerToBack } from '../../../helpers/checkRouterPrevPath';
import { FolderStatusEnum } from '../../../interfaces/training.interface';
import FolderDetailLayout from '../../../layouts/FolderDetailLayout/FolderDetailLayout';

const InsideSpace = ({ infoGroup }: any) => {
  const router = useRouter();

  const [folderId, setFolderId] = useState<string>('');

  useEffect(() => {
    if (router.isReady) {
      setFolderId(router.query?.gid as string);
    }
  }, [router]);

  const { data: folder } = useQuery<{ [key: string]: any }>(
    [FOLDER_INFO, folderId],
    () => getFolderInfo(folderId),
    {
      refetchOnMount: false,
      keepPreviousData: true,
      enabled: false,
      initialData: infoGroup,
      retry(_failureCount, _error: any) {
        return false;
      },
      onError(_err) {
        const err = _err as AxiosError;
        if (err.response?.status === 404) {
          router.push(PATH_NAME.NOT_FOUND);
        }
      },
    }
  );

  const [mineRole, setMineRole] = useState<TRoleAccess>(ROLE_ACCESS.Revoked);

  useQuery<TRoleAccess>(
    [GROUP_ROLE_ACCESS, folderId],
    () => {
      return getMineRoleOfFolder({ folderId }) as any;
    },
    {
      refetchOnMount: true,
      enabled: !!folderId,
      retry(_failureCount, error) {
        if ((error as AxiosError)?.response?.status === 401) {
          if (_failureCount === 2) return false;
          return true;
        }
        return false;
      },
      onSuccess(data) {
        setMineRole(data);
      },
      onError() {
        setMineRole(ROLE_ACCESS.Revoked);
      },
      initialData: ROLE_ACCESS.Revoked,
    }
  );

  return (
    <FolderDetailLayout>
      {/* <GroupHeader
          folderId={folderId}
          mineRole={mineRole}
          setOffsetHeight={setOffsetHeight}
          folderStatus={folder?.status as FolderStatusEnum}
        /> */}
      <div className="mx-auto w-full max-w-container">
        {/* General Group Info Bar */}
        <GeneralGroupInfoBar
          folderStatus={folder?.status as FolderStatusEnum}
          mineRole={mineRole}
        />
        {/* tabs */}
        <TabsInGroupDetail
          folder={folder}
          folderId={folderId}
          mineRole={mineRole}
          folderStatus={folder?.status as FolderStatusEnum}
        />
      </div>
    </FolderDetailLayout>
  );
};
interface GroupHeaderProps {
  folderId: string;
  mineRole: TRoleAccess | undefined;
  setOffsetHeight: Dispatch<SetStateAction<number>>;
  folderStatus: FolderStatusEnum;
}
export function GroupHeader({
  folderId,
  mineRole,
  setOffsetHeight,
  folderStatus,
}: GroupHeaderProps) {
  const router = useRouter();
  const headerRef = useRef<HTMLDivElement>(null);
  const isDesktop = useMediaQuery('(min-width:640px)');
  const [currentTab, setCurrentTab] = useState<string>('');
  const [searchValue, setSearchValue] = useState<string>('');
  const [showSearchScreen, setShowSearchScreen] = useState<boolean>(false);

  const showAddNewBtnCondition =
    [ROLE_ACCESS.Owner, ROLE_ACCESS.Editor].includes(mineRole as ROLE_ACCESS) &&
    currentTab == 'document';

  const validateUser =
    folderStatus === FolderStatusEnum.Private
      ? checkIsUserJoined(mineRole as ROLE_ACCESS | undefined)
      : true;

  useEffect(() => {
    function handleOnMessage(e: MessageEvent) {
      if (
        e.origin === window.location.origin &&
        e.data?.message === 'stateChange'
      ) {
        setCurrentTab(e.data?.data);
      }
    }

    window.addEventListener('message', handleOnMessage);

    return () => {
      window.removeEventListener('message', handleOnMessage);
    };
  }, []);

  useEffect(() => {
    if (router.isReady) {
      setSearchValue((router.query?.searchKey as string) || '');
      if (
        !isDesktop &&
        router.pathname === PATH_NAME.MY_GROUPS_SEARCH &&
        router.query?.searchKey !== undefined &&
        validateUser
      ) {
        setShowSearchScreen(true);
      }
    }
  }, [isDesktop, router, validateUser]);

  useEffect(() => {
    const headerHeight = headerRef?.current?.offsetHeight;
    setOffsetHeight(headerHeight as number);
  }, [currentTab]);

  return (
    <div
      ref={headerRef}
      className="sticky top-0 z-[10] -mx-3 bg-[#FCFCFC] px-[20px] sm:-mx-5"
    >
      <TrainingSectionHeader>
        <div className="relative flex h-[58px] items-center justify-between gap-6 py-2 sm:h-[62px] sm:py-2.5">
          {showSearchScreen && !isDesktop && (
            <div className="absolute bottom-0 left-0 right-0 top-0 z-10 -mx-1 bg-white">
              <div className="mx-1 flex h-full items-center gap-x-2">
                <FilledVectorLeft
                  color="#009CE0"
                  className="mx-3 cursor-pointer"
                  onClick={() => setShowSearchScreen(false)}
                />
                <SearchInput
                  value={searchValue}
                  setValue={setSearchValue}
                  isObject={false}
                  placeholder="Tìm kiếm trong nhóm"
                  redirectAfterClear={PATH_NAME.MY_GROUPS_DETAIL.replace(
                    '[gid]',
                    folderId
                  )}
                  redirectAfterEnter={PATH_NAME.MY_GROUPS_SEARCH.replace(
                    '[gid]',
                    folderId
                  )}
                  pathname={PATH_NAME.MY_GROUPS_SEARCH}
                />
              </div>
            </div>
          )}

          {/*START RETURN BUTTON    */}
          <TrainingSectionHeader.ReturnButton>
            <div
              className="flex cursor-pointer items-center gap-x-0 text-primary_blue"
              onClick={() => routerToBack(router, PATH_NAME.MY_GROUPS)}
            >
              <FilledVectorLeft
                width={13}
                height={13}
                className="mx-3 cursor-pointer"
              />
              <p className="whitespace-nowrap text-base font-normal">
                Quay lại
              </p>
            </div>
          </TrainingSectionHeader.ReturnButton>
          {/* END RETURN BUTTON    */}

          {/*START SEARCH  */}
          {isDesktop && validateUser && (
            <SearchInput
              value={searchValue}
              setValue={setSearchValue}
              isObject={false}
              placeholder="Tìm kiếm trong nhóm"
              className=" max-w-[588px]"
              redirectAfterClear={PATH_NAME.MY_GROUPS_DETAIL.replace(
                '[gid]',
                folderId
              )}
              redirectAfterEnter={PATH_NAME.MY_GROUPS_SEARCH.replace(
                '[gid]',
                folderId
              )}
              pathname={PATH_NAME.MY_GROUPS_SEARCH}
            />
          )}
          {!isDesktop && validateUser && (
            <SearchIcon
              className="cursor-pointer text-grey_helper"
              onClick={() => setShowSearchScreen(true)}
            />
          )}
          {/* END SEARCH  */}

          {/*START ADD NEW BUTTON */}
          {showAddNewBtnCondition ? (
            <div className="flex">
              {/* if you change the height of button you need to change the height of  TrainingSectionHeader to fix with the new height of addnewbutton*/}
              <TrainingSectionHeader.AddNewButton idSaveOn={folderId} />
            </div>
          ) : (
            <div className="hidden lg:block"></div>
          )}
          {/* END ADD NEW BUTTON */}
        </div>
      </TrainingSectionHeader>
    </div>
  );
}

export default InsideSpace;

export const getServerSideProps: GetServerSideProps = async (context) => {
  cookieCommons.setContext(context);
  const { gid } = context.query;

  const folderId = gid as string;

  try {
    const infoGroup = await getFolderInfo(folderId);

    const seo = JSON.parse(
      JSON.stringify(
        useSEO(infoGroup.folderName + '', {
          description: getFirst150Characters(
            removeBreakLinesAndSpaces(infoGroup?.description)
          ),
        })
      )
    );

    return {
      props: {
        infoGroup,
        seo,
      },
    };
  } catch (error) {
    return {
      redirect: {
        destination: PATH_NAME.NOT_FOUND,
        permanent: false,
      },
    };
  }
};
